/**
 * Access Labs, the second SFTP lab integration beside Vibrant.
 */

/**
 * The opt-in account module that switches Access ordering and the Access Admin
 * page on. It is the lowered catalog title "Access Labs", and must equal the
 * server's AccessLabsModule::KEY: a mismatch hides the screens while the
 * endpoints stay open, or the reverse. Access results are not gated by it.
 */
export const ACCESS_LABS_MODULE_KEY = 'access labs';

/**
 * What the test search says, on the Admin page and the order form. Access's
 * compendium is too large to list, so nothing shows until something is typed,
 * and the server returns only the first matches (meta.capped).
 */
export const ACCESS_TEST_SEARCH_MESSAGES = {
  prompt: 'Type part of a test code or name',
  noMatch: 'No tests match',
  capped: 'Showing the first matches. Type more to narrow.',
} as const;

/** A test's name, or its code when Access sent it with no name. */
export function accessTestName(testCode: string, description: string): string {
  return description.trim() !== '' ? description : `Code ${testCode} (no name from Access)`;
}

/** The React Query key of a patient's Access orders (AccessSubTab), refreshed after an order or a resend. */
export function accessOrdersQueryKey(patientId: number) {
  return ['patient-access-orders', patientId] as const;
}
